import { render, staticRenderFns } from "./ProductBuy.vue?vue&type=template&id=0f4e3440&"
import script from "./ProductBuy.vue?vue&type=script&lang=js&"
export * from "./ProductBuy.vue?vue&type=script&lang=js&"
import style0 from "./ProductBuy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports